import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppConfig } from '../../shared/config/app-config';

export const MfeMarketerOnboardingGuard: CanActivateFn = () => {
    const router = inject(Router);
    const shouldShowMarketerOnboardingMfe = AppConfig?.SHOW_MARKETER_ONBOARDING_MFE;
    if (!shouldShowMarketerOnboardingMfe) {
        router.navigateByUrl('/');
        return false;
    }
    return true;
};

